import { PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.BeliefConceptSlice} BeliefConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BeliefConceptSlice>} BeliefConceptProps
 * @param {BeliefConceptProps}
 */
const BeliefConcept = ({ slice, index }) => {
  return (
    <section data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white bg-grain ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="flex flex-col pt-10 pb-12 md:py-20 px-4 md:px-7 lg:px-10  max-w-[1400px] m-auto">
        <div className="h2-like md:max-w-[50%] lg:max-w-[580px] mb-30px md:mb-11">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div className="flex flex-col md:flex-row">
          {
            slice.primary.cards.map((card, i) => {
              return <div key={i} className={` ${i == 0 ? 'md:mr-5 mb-7 md:mb-0' : 'md:-mt-20 md:ml-5'} md:w-1/2`}>
                <div className={`rounded-[30px] ${i == 0 ? 'bg-beige' : 'bg-light-pink'} w-full p-30px lg:px-12 lg:py-10`}>
                  <div className="belief-title mb-1 md:mb-3.5">
                    <PrismicRichText field={card.title} />
                  </div>
                  <div className="belief-sub-title pb-6 border-b-2 border-solid border-dark-grey">
                    {card.subtitle}
                  </div>
                  <div className="py-6 border-b-2 border-solid border-dark-grey" >
                    <PrismicRichText field={card.text_1} />
                  </div>
                  <div className="pt-6">
                    <PrismicRichText field={card.text_2} />
                  </div>
                </div>
              </div>
            })
          }
        </div>
      </div>
    </section >
  );
};

export default BeliefConcept;
